import React from "react";
import styled from "styled-components";

import HorizontalScroll from "react-scroll-horizontal";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";

const StaticShipping2 = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed showCart cartIconColor={"#0F475D"} />
      {/*  Body */}

      <Container>
        <HorizontalScroll
          reverseScroll={true}
          style={{
            paddingLeft: "100px",
            width: "100vw",
            paddingTop: "100px",
          }}
        >
          <SecondContainer>
            <Title>innovation fund</Title>

            <div style={{ display: "flex", gap: "50px", width: "2000px" }}>
              <div style={{ width: "70%" }}>
                <SecondaryTitle>
                  What Are The Details Of Our Innovation Fund?
                </SecondaryTitle>
                <Text>
                  At evrbed we are committed to mattress sustainability and the
                  environment. As part of that commitment we will support
                  research and development of mattress materials to support the
                  entire mattress life cycle. The world doesn’t need more
                  mattresses being made and sent to the landfill in an endless
                  cycle of consumerism. By using better materials, and
                  techniques mattresses can last longer which does help. That
                  being said, designing mattresses to be easily recycled takes
                  concerted effort.
                </Text>
                <Text>
                  We will support projects and companies that are working in
                  this field whether it is designing and making new materials,
                  or end of lifecycle equipment or support for mattress
                  recyclers. These efforts will be supported by voluntary time
                  and monetary.
                </Text>
                <Text>
                  If you are looking for support in these efforts, please
                  contact us at: XXX@evrbed.com
                </Text>
              </div>
              <div style={{ position: "relative", width: "60%" }}>
                <SecondaryTitle>How We Give Back</SecondaryTitle>
                <Text>
                  1% of all sales goes into our innovation fund as well as
                  towards non profits that are in the Recycling, Sustainability
                  and Environmental. If we are replacing an existing mattress in
                  your home we will have your old mattress recycled. We also
                  commit to recycling your evrbed in the future. It might be 30
                  years down the road, but we will cover the recycling expense
                  when and if you need it.
                </Text>
                <LeafDecorator />
                <GreenDecorator />
              </div>
            </div>
          </SecondContainer>
        </HorizontalScroll>
      </Container>

      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default StaticShipping2;

const Container = styled.div`
  margin: 0 auto;
  //max-width: 1920px;
  height: 90vh;
  padding: 100px 0 0px 0px;
  //overscroll-behavior: contain;
  //overflow: auto;
`;

const SecondContainer = styled.div`
  //margin: 0 auto;
  //max-width: 1920px;
  height: 100vh;
  //position: relative;
  //z-index:4000;
  //padding: 100px 0 0px 150px;
  //overscroll-behavior: contain;
  //overflow: auto;
`;

const LeafDecorator = styled.div`
  border-radius: 0 40% 0 40%;
  border: 6px solid #b1d34a;
  width: 7vw;
  height: 17vh;
  position: absolute;
  left: -250px;
  top: -225px;
  opacity: 35%;
  z-index: 99;
`;

const GreenDecorator = styled.div`
  border-radius: 40% 0 40% 0;
  background-color: #dceada;
  width: 14vw;
  height: 20vh;
  position: absolute;
  left: -200px;
  top: -180px;
  opacity: 40%;
`;

const Title = styled.h1`
  color: #3e703d;
  font-size: 84px;
  font-family: elena-web-basic;
  font-weight: bold;
  margin-bottom: 32px;
`;

const SecondaryTitle = styled.h2`
  margin-bottom: 32px;
  color: #3e703d;
  font-size: 42px;
  font-family: noto-sans;
  font-weight: bold;
  position: relative;
  z-index: 1500;
`;

const Text = styled.p`
  font-family: noto-sans;
  font-size: 18px;
  color: #3e703d;
  padding-right: 120px;
`;
